export default __webpack_public_path__ + "static/media/et.370673cb.svg";